export default __webpack_public_path__ + "static/ai-2405759936c727d0a534cbf76dd4d8c0.png";